<template>
  <div class="header-message-dialog">
    <qc-dialog
      v-if="showDialog"
      class="app-header-message-dialog__noscoped"
      title="消息中心"
      :width="679"
      type="custom"
      :show="true"
      :default-cancel="false"
      @close="onClose"
      append-to-body
    >
      <div class="message-dialog-detail">
        <div class="message-dialog-left">
          <div v-for="(item, index) in mediaTypeList" :key="index" class="message-type-item"
            :class="{ active: activeIndex === index }" @click="changeMessageType(index)">
            <span>{{item.label}}</span>
            <span v-if="item.unread && item.unread > 0">
              ({{item.unread}})
            </span>
          </div>

          <div class="message-all-read">
            <el-button type="primary" size="small" plain @click="reqClearUnreadMsgApi">全部已读</el-button>
          </div>
        </div>
        <div class="message-dialog-right">
          <!-- 页面内容 [[ -->
          <div class="message-dialog-list">
            <div v-if="showMsgList" class="message-list-container">
              <!-- ]] 消息列表 -->
              <div class="message-list-item" v-for="(item, index) in msgList" :key="index" @click="msgClick(item, index)">
                <div class="message-item-img">
                    <i :class="['ui-imgblock__img-ico', 'message-item-icon', item.icoClass]" />
                </div>
                <div class="message-item-info">
                  <div class="message-info-top">
                    <span class="message-info-title">
                      {{ item.title }}
                      <span v-if="item.unread" class="message-unread-circle"></span>
                    </span>
                    <span class="message-info-date">{{ item.date }}</span>
                  </div>
                  <div class="message-info-bottom">{{ item.content }}</div>
                </div>
              </div>
            </div>

            <!-- 无消息数据 [[ -->
            <div v-if="!showMsgList" class="msg-nodata">
              <empty-data emptyData="暂无相关消息" />
            </div>
            <!-- ]] 无消息数据 -->
          </div>
          <!-- ]] 页面内容 -->

          <div class="message-pagination">
              <!-- 翻页 [[ -->
              <qc-pagination
                :total-num="totalMsg"
                :curr-page.sync="currPage"
                :page-size.sync="pageSize"
                @change="reqMsgApi"
              />
              <!-- ]] 翻页 -->
          </div>

        </div>
      </div>
    </qc-dialog>
  </div>
</template>

<script>
import EmptyData from '@/components/EmptyData';
import { formatMsgDate } from '../../../src/pages/messageCenter/utils';
import { MESSAGE_TYPE_LIST } from './constant';
import fetch from '@/lib/fetch';
import { mapMutations, mapState } from 'vuex';
import { findIndex, forEach, map } from 'lodash';

export default {
  components: {
    EmptyData,
  },
  watch: {
    showDialog(val) {
      if (val) {
        console.log('showDialog', this.mediaTypeList);
        this.reqMsgApi();
      }
    },
    // 监听变更，未读消息变更则进行重新加载列表
    clearKey: {
      handler() {
        this.requstUnreadList();
      },
    },
  },
  data() {
    return {
      showDialog: false,
      mediaTypeList: MESSAGE_TYPE_LIST,
      activeIndex: 0,
      msgList: [],
      currPage: 1,
      pageSize: 10,
      totalMsg: 0,
    };
  },
  computed: {
    ...mapState('userCenter', ['profile']),
    ...mapState('messageCenter', ['totalUnreadMsg', 'mediaMatch', 'clearKey']),

    showMsgList() {
      return this.msgList.length > 0;
    },
  },
  created() {
    this.requstUnreadList();
  },
  methods: {

    ...mapMutations('messageCenter', [
      'updateTotalUnreadMsg',
    ]),
    onClose() {
      this.showDialog = false;
    },
    changeMessageType(index) {
      this.activeIndex = index;
      this.reqMsgApi();
    },
    // 获取未读接口的列表，该接口也用于更新获取用户数据
    requstUnreadList() {
      const reqData = {
        user_id: this.profile.user_id,
      };
      fetch.post('v3/announcement_center/query_unread_summary_list', reqData)
        .then((res) => {
          const resData = res || {};
          this.updateTotalUnreadMsg(resData.total || 0);
          this.processUnreadNum(resData.type_count_map || []);
        })
        .catch(() => {
        });
    },
    // 未读消息进行数量赋值
    processUnreadNum(listObj) {
      // 将数值设置为初始值
      this.mediaTypeList = map(this.mediaTypeList, item => ({
        ...item,
        unread: 0,
      }));
      // this.mediaTypeList
      forEach(listObj, (value, key) => {
        const findKeyIndex = findIndex(this.mediaTypeList, item => Number(item.value) === Number(key));
        this.mediaTypeList[findKeyIndex].unread = Number(value) > 0 ? value : 0;
      });
    },
    // 获取消息列表接口
    reqMsgApi() {
      const closeLoadingTip = this.$tip.loading({
        message: '加载中...',
        duration: 0,
      });

      const reqData = {
        user_id: this.profile.user_id,
        page_num: this.currPage,
        page_size: this.pageSize,
        status: -1, // 消息状态 -1 全部
        media_type: -1,
        type: MESSAGE_TYPE_LIST[this.activeIndex].value, // 媒体类型 -1表示全部
      };
      fetch.post('v3/announcement_center/query_message_list', reqData)
        .then((res) => {
          if (res.code !== 0) {
            this.$tip.error(res.msg || res.message || '消息获取失败，请稍后再试');

            return;
          }

          const resData = res || {};
          const resMsgList = resData.message_list || [];
          this.totalMsg = Number(resData.total) || 0;
          this.msgList = resMsgList.map((obj) => {
            const dateStr = obj.create_at ? formatMsgDate(obj.create_at) : '';

            return {
              id: obj.id || '',
              status: obj.status,
              unread: obj.status === 0,
              icoClass: (this.mediaMatch[obj.media_type] && this.mediaMatch[obj.media_type].className) || 'logo-eshop',
              title: obj.title || '',
              content: this.processContent(obj.content),
              date: dateStr,
            };
          });
        })
        .catch(() => {
          this.$tip.error('消息获取失败，请稍后再试');
        })
        .finally(() => {
          if (closeLoadingTip !== null) closeLoadingTip();
        });
    },
    // 处理数据
    processContent(content) {
      // 正则匹配替换掉图片标签为图片，避免被渲染出来
      const contentDeal = content.replace(new RegExp(/<img [^>]*>/, 'g'), ' [图片] ');
      // 该元素会被自动销毁，无需处理
      const span = document.createElement('span');
      span.innerHTML = contentDeal;
      const spanInnerText = span.innerText || '';
      let ellipsis = '';
      if (spanInnerText.length > 34) {
        ellipsis = '...';
      }

      // 默认仅展示20个字符，点击详情查看具体内容
      return spanInnerText.substring(0, 34) + ellipsis;
    },
    msgClick(item, index) {
      this.showDialog = false;
      const msgID = this.msgList[index].id;
      if (this.$route.path === '/messageDetail') {
        window.location.hash = `#/messageDetail?msgid=${msgID}`;
      } else {
        this.$router.push({
          path: '/messageDetail',
          query: { msgid: msgID },
        });
      }
    },
    // 清除全部未读消息
    reqClearUnreadMsgApi() {
      const closeLoadingTip = this.$tip.loading({
        message: '加载中...',
        duration: 0,
      });
      fetch.post('v3/announcement_center/update_message_status_by_user', {
        user_id: this.profile.user_id,
        status: 1,
      }).then((res) => {
        if (res.code !== 0) {
          this.$tip.error(res.msg || res.message || '请求失败，请稍后再试');

          return;
        }

        this.$tip.success('清除成功');
        // 请求成功后重新加载列表接口
        this.requstUnreadList();
        this.reqMsgApi();
      })
        .catch(() => {
          this.$tip.error('请求失败，请稍后再试');
        })
        .finally(() => {
          if (closeLoadingTip !== null) closeLoadingTip();
        });
    },
  },
};
</script>

<style lang="less" scoped>
.message-dialog-detail {
  height: 382px;
  display: flex;
  box-sizing: border-box;
  border-top: 1px solid rgba(151,151,151,0.10);
  .message-dialog-left {
    width: 117px;
    height: 100%;
    box-sizing: border-box;
    border-right: 1px solid rgba(151,151,151,0.10);
    position: relative;
    .message-all-read {
      position: absolute;
      left: 20px;
      bottom: 20px;
    }
    .message-type-item {
      width: 100%;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &:hover, &.active {
        background: var(--ui-bg-color);
        color: var(--ui-main-color);
      }
    }
  }
  .message-dialog-right {
    flex: 1;
    box-sizing: border-box;
    padding-bottom: 54px;
    position: relative;
    .message-dialog-list {
      height: 100%;
      position: relative;
      .msg-nodata {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .message-list-container {
        height: 100%;
        overflow-y: scroll;
        .message-list-item {
          box-sizing: border-box;
          height: 69px;
          display: flex;
          cursor: pointer;

          &:hover {
            background: var(--ui-bg-color);
          }
          .message-item-img {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 15px;
            margin-left: 15px;
            border-bottom: 1px solid #FAFAFA;

            .message-item-icon {
              width: 38px;
              height: 38px;
            }
          }
          .message-item-info {
            flex: 1;
            height: 100%;
            box-sizing: border-box;
            margin-right: 15px;
            padding: 15px 0;
            line-height: 20px;
            border-bottom: 1px solid #FAFAFA;

            .message-info-top {
              display: flex;
              justify-content: space-between;
              .message-info-title {
                color: rgba(0,0,0,0.80);
                .message-unread-circle {
                  display: inline-block;
                  width: 6px;
                  height: 6px;
                  background: #E02020;
                  border-radius: 50%;
                  position: relative;
                  top: -1px;
                }
              }
              .message-info-date {
                color: #979797;
              }
            }
            .message-info-bottom {
              color: var(--ui-secondary-font-color);
              width: 100%;
            }
          }
        }
      }
    }
    .message-pagination {
      border-top: 1px solid #F5F5F5;
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;

      /deep/ .tc-15-page {
        border: 0 none;
      }
    }
  }
}
</style>

<style lang="less">
.app-header-message-dialog__noscoped {
  .tc-15-rich-dialog {
    padding: 11px 0 0 0;
    border-radius: 4px;
  }
  .tc-15-rich-dialog-hd {
    height: 24px;
    margin: 0 20px 10px;
    box-sizing: border-box;
    position: relative;
  }
}
</style>
